module.exports = __webpack_public_path__ + "static/media/admin_users.928443cf.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/admin_users.md
// module id = 1084
// module chunks = 0